import { type BaseNotificationData, type NotificationDefinition } from "../index";
import { NotificationType } from "../NotificationType";

export interface GeneralNotificationData extends BaseNotificationData {
  subTypeCode: NotificationType.GeneralNotification;
  title: string;
  content: string;
}

export const GeneralNotificationDefinition: NotificationDefinition<GeneralNotificationData> = {
  type: NotificationType.GeneralNotification,
  renderTitle: (data) => {
    return <div dangerouslySetInnerHTML={{ __html: data.title }} />;
  },
  renderTitleGA: (data) => {
    return `${data.title}`;
  },
  renderContents: (data, { markAsRead }) => {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: data.content }}
        onClick={(e) => {
          if ((e.target as HTMLElement)?.closest("a") !== null) {
            markAsRead(data);
          }
        }}
      />
    );
  },
};
